// TODO: 🚨 HIGH PRIORITY! We need to strictly type rules, error, control and defaultValue
/* eslint-disable @typescript-eslint/no-explicit-any */
import type { PropsWithChildren, ReactNode } from 'react';
import type { FormControlProps, InputProps } from '@chakra-ui/react';
import type { IconName } from '../icons/Icon.map';

const inputTypes = ['text', 'password', 'email', 'phone', 'tel', 'number'] as const;
const specialTypes = [
    'select',
    'checkbox',
    'hidden',
    'autocomplete',
    'textarea',
    'file',
    'invisible',
] as const;

export const fieldTypes = [...inputTypes, ...specialTypes];

export type InputType = (typeof inputTypes)[number];

export type FieldType = (typeof fieldTypes)[number];

export function isInputType(type: unknown): type is InputType {
    return typeof type === 'string' && inputTypes.some((a) => a === type);
}

export type FieldConfig = PropsWithChildren<
    Pick<InputProps, 'placeholder' | 'autoComplete' | 'maxWidth'> & {
        name: string;
        id?: string;
        label?: ReactNode;
        labelRef?: React.MutableRefObject<HTMLElement | undefined>;
        ariaLabel?: InputProps['aria-label'];
        autoFocus?: boolean;
        isInvalid?: boolean;
        type: FieldType;
        options?: {
            label: string;
            value: string | number;
            icon?: React.ReactNode;
        }[];
        comboboxOptions?: any[];
        formLabel?: ReactNode;
        className?: FormControlProps['className'];
        helpText?: ReactNode;
        // FIXME: We need to find a better way to handle the props for the control that will be render and assert the type correctly
        inputProps?: Record<string, any> | ((...args: any[]) => void);
        // FIXME: The following types had to be set as any a correct type can't be inferred even using the ones from the package #tech-debt
        rules?: any;
        error?: any;
        control: any;
        defaultValue?: any;
        variant?: 'new-style' | 'no-margin';
        rightIcon?: IconName;
        leftIcon?: IconName;
        multiple?: string;
        accept?: string;
        isDisabled?: boolean;
        iconName?: IconName;
        leftText?: string | ReactNode;
        useStreetAddressOnly?: boolean;
    }
>;
